export default __webpack_public_path__ + "static/Stone_Cliff_Platform-d119c08b9a9f394c516c3cfcc6395927.png";